import { render, staticRenderFns } from "./ProfitAndLossIndexRow.vue?vue&type=template&id=661ac1c0&scoped=true&"
import script from "./ProfitAndLossIndexRow.vue?vue&type=script&lang=js&"
export * from "./ProfitAndLossIndexRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661ac1c0",
  null
  
)

export default component.exports